import _Field from "redux-form/es/Field";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import { CheckboxInput } from 'swag-client-common/components/inputs/checkbox-input';
import classes from './form-checkbox.scss';
export default class FormCheckbox extends React.PureComponent {
  render() {
    return /*#__PURE__*/React.createElement(_Field, _extends({
      component: CheckboxInput,
      type: "checkbox"
    }, this.props, {
      className: classNames(classes.field, this.props.className)
    }));
  }
}